import { render, staticRenderFns } from "./GestionEquipoDepartamento.vue?vue&type=template&id=97e28956&scoped=true"
import script from "./GestionEquipoDepartamento.vue?vue&type=script&lang=js"
export * from "./GestionEquipoDepartamento.vue?vue&type=script&lang=js"
import style0 from "./GestionEquipoDepartamento.vue?vue&type=style&index=0&id=97e28956&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97e28956",
  null
  
)

export default component.exports